export const NotificationTypes = {
  SET_NOTIFICATION: "NOTIFICATION::SET_NOTIFICATION",
};
